import { render, staticRenderFns } from "./AcceptReservation.vue?vue&type=template&id=32f75a22"
import script from "./AcceptReservation.vue?vue&type=script&lang=js"
export * from "./AcceptReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports